import { render, staticRenderFns } from "./AsideGaleria.vue?vue&type=template&id=55a024db&scoped=true&lang=pug"
import script from "./AsideGaleria.vue?vue&type=script&lang=js"
export * from "./AsideGaleria.vue?vue&type=script&lang=js"
import style0 from "./AsideGaleria.styl?vue&type=style&index=0&id=55a024db&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a024db",
  null
  
)

export default component.exports